
export const getPageAccessorUrlForUrl = (url)=>
  `/page-accessor?url=${url}`;